import { render, staticRenderFns } from "./NewComposerTiktok.vue?vue&type=template&id=2fbe8d97&scoped=true&"
import script from "./NewComposerTiktok.vue?vue&type=script&lang=js&"
export * from "./NewComposerTiktok.vue?vue&type=script&lang=js&"
import style0 from "vue-slick-carousel/dist/vue-slick-carousel.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./NewComposerTiktok.vue?vue&type=style&index=1&id=2fbe8d97&prod&lang=scss&"
import style2 from "./NewComposerTiktok.vue?vue&type=style&index=2&id=2fbe8d97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe8d97",
  null
  
)

export default component.exports